(function(angular){
    'use strict';

    /**********************************************************************
     * The report list service performs any API interactions required
     * by the report list component.
     *********************************************************************/
    angular.module('bmrcReportGenerateService', []).service('bmrcReportGenerateService', [function() {
        var service = this;
        service.acceptFunc = function(){};
        service.cancelFunc = function(){};
        service.getSelectedFolder = function(){};
        service.definition = {
            sendToOnvioDocumentsVisible: true,
            useSelectFolder: false
        }; // defaults

        service.setAcceptFunc = function(acceptFunc){
            if (acceptFunc && typeof acceptFunc === 'function') {
                service.acceptFunc = acceptFunc;
            }
        };

        service.getAcceptFunc = function(){
            return service.acceptFunc;
        };

        service.setCancelFunc = function(cancelFunc){
            if (cancelFunc && typeof cancelFunc === 'function') {
                service.cancelFunc = cancelFunc;
            }
        };

        service.getCancelFunc = function(){
            return service.cancelFunc;
        };

        service.setDefinition = function(definition){
            if (definition) {
                for (var prop in definition) {
                    if (definition.hasOwnProperty(prop)) {
                        service.definition[prop] = definition[prop];
                    }
                }
            }
        };

        service.getDefinition = function(){
            return service.definition;
        };

        service.setGetSelectedFolder = function(getSelectedFolderFunc){
            if (getSelectedFolderFunc && typeof getSelectedFolderFunc === 'function') {
                service.getSelectedFolder = getSelectedFolderFunc;
            }
        };

        service.getGetSelectedFolder = function(){
            return service.getSelectedFolder;
        };

    }]);
})(window.angular);
